<template>
  <base-dialog :titleHtml="title">
    <h2>Lähtötiedoissa on puutteita</h2>
    <p>Valitse kaikki lähtötietojen kohdat ja sen jälkeen korjaus.</p>
    <div class="text-center">
      <img src="../../assets/huom_valitse.png" />
    </div>
  </base-dialog>
</template>


<script>
  import BaseDialog from "./BaseDialog"

  export default {
    components: {
      BaseDialog
    },
    computed: {
      title() {
        return '<strong class="text-warning">HUOM</strong>'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dialog/ParamsNotSetDialog.vue